// eslint-disable-next-line import/no-extraneous-dependencies
import 'scroll-into-view-if-needed';
import _Form from './Form';
import { registerComponent } from '../utils';
const Form = registerComponent(_Form);
export default Form;